import i18n from "i18next";

export class I18nService {
    getLanguage() {
        let language = i18n.language;
        if (typeof language === 'undefined') {
            return 'en';
        }

        language = language.toLowerCase();
        if (language === 'de' || language === 'en') {
            return language;
        }
        return 'en';
    }
}